(() => {
  if (window.DriplockedRecommendations) { window.DriplockedRecommendations.init(); return; }
  const controllers = new Map();
  function setup(root) {
    const abort = new AbortController();
    let resize;
    const bind = () => {
      const grid = root.querySelector('.related-product-row__grid');
      const previous = root.querySelector('.related-product-row__arrow--prev');
      const next = root.querySelector('.related-product-row__arrow--next');
      if (!grid || !previous || !next) return;
      root.querySelector('.related-product-row__controls').hidden = false;
      const update = () => { previous.disabled = grid.scrollLeft < 1; next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2; };
      root.addEventListener('click', event => {
        const button = event.target.closest('.related-product-row__arrow');
        if (!button) return;
        const width = grid.querySelector('.related-product-row__item')?.getBoundingClientRect().width || 0;
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        const count = Math.max(1, Math.floor((grid.clientWidth + gap) / (width + gap)));
        grid.scrollBy({left: (button === previous ? -1 : 1) * count * (width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal: abort.signal});
      grid.addEventListener('scroll', update, {passive: true, signal: abort.signal});
      resize = new ResizeObserver(update); resize.observe(grid); update();
    };
    async function load() {
      try {
        const response = await fetch(root.dataset.url, {signal: abort.signal});
        if (!response.ok) throw new Error('Recommendations unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = doc.getElementById(root.id);
        if (!result?.querySelector('.related-product-row__item')) { root.hidden = true; return; }
        if (!root.isConnected) return;
        root.innerHTML = result.innerHTML; root.hidden = false; bind();
      } catch (error) { if (error.name !== 'AbortError') root.hidden = true; }
    }
    if (root.querySelector('.related-product-row__item')) bind(); else load();
    return () => { abort.abort(); resize?.disconnect(); };
  }
  function init() {
    for (const [root, cleanup] of controllers) if (!root.isConnected) { cleanup(); controllers.delete(root); }
    document.querySelectorAll('.product-recommendations[data-url]').forEach(root => { if (!controllers.has(root)) controllers.set(root, setup(root)); });
  }
  window.DriplockedRecommendations = {init};
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => { for (const [root, cleanup] of controllers) if (event.target.contains(root)) { cleanup(); controllers.delete(root); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
})();
